import { TaskProps } from "@/interfaces/tasks_types";
import { ProgressBar } from "./ProgressBar";
import { NamesInCategory } from "./NamesInCategory";

type TaskOverviewProps = {
    tasks: TaskProps[]
    taskCounts: { [key: string]: { total: number; completed: number; }; };
    totalTasks: number;
    totalProgress: number;
}

export function TaskOverview({ tasks, taskCounts, totalTasks, totalProgress }: TaskOverviewProps) {
    const users = NamesInCategory(tasks)
    return (
        <div>
            <h3 className="mb-2 text-stone-900 dark:text-stone-50">Task Overview: {totalTasks > 0 && totalTasks + " Tasks"}</h3>
            {tasks.length > 0 ? (
                <div className="p-4 border-2 rounded-md bg-stone-100 dark:bg-stone-800 border-stone-200 dark:border-stone-700">
                    <div className="flex flex-col gap-2">
                        <ProgressBar 
                            label="Mechanical"
                            completed={taskCounts.Mechanical.completed}
                            total={taskCounts.Mechanical.total}
                            barColor="bg-green-200"
                            users={users.Mechanical}
                        />
                        <ProgressBar 
                            label="Electrical"
                            completed={taskCounts.Electrical.completed}
                            total={taskCounts.Electrical.total}
                            barColor="bg-yellow-200"
                            users={users.Electrical}
                        />
                        <ProgressBar 
                            label="Plumbing"
                            completed={taskCounts.Plumbing.completed}
                            total={taskCounts.Plumbing.total}
                            barColor="bg-blue-200"
                            users={users.Plumbing}
                        />
                        <ProgressBar 
                            label="Fire Protection"
                            completed={taskCounts["Fire Protection"].completed}
                            total={taskCounts["Fire Protection"].total}
                            barColor="bg-red-200"
                            users={users["Fire Protection"]}
                        />
                        <ProgressBar 
                            label="Other"
                            completed={taskCounts.Other.completed}
                            total={taskCounts.Other.total}
                            barColor="bg-purple-200"
                            users={users.Other}
                        />
                    </div>

                    <p className="mt-2 text-nowrap text-stone-900 dark:text-stone-50">Total Progress: {totalProgress.toFixed(2)}%</p>
                    {totalProgress === 100 && <p className="mt-2 text-green-500 text-nowrap dark:text-stone-50">All Tasks Closed!</p>}
                </div>
            ) : (
                <p className="text-stone-900 dark:text-stone-50">(No tasks found)</p>
            )}
        </div>
    )
}